import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommonNotificationService {

  webNotificationToken: any;
  notificationCount: any;
  notificationArray: any;

  public ProfileData = new BehaviorSubject<boolean>(false);

  constructor() {
    this.webNotificationToken = new BehaviorSubject('');
    this.notificationCount = new BehaviorSubject('');
    this.notificationArray = new BehaviorSubject('');
  }

  getWebNotificationToken() {
    return this.webNotificationToken;
  }

  setWebNotificationToken(webNotificationToken) {
    this.webNotificationToken.next(webNotificationToken);
  }

  getNotificationCount() {
    return this.notificationCount;
  }

  setNotificationCount(count) {
    this.notificationCount.next(count);
  }

  getNotificationArray() {
    return this.notificationArray;
  }

  setNotificationArray(array) {
    this.notificationArray.next(array);
  }

}
